module.exports = __webpack_public_path__ + "static/media/royal-mail.a48ccc37.svg";